import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IGetOrganizationByShortNameInput,
  IGetOrganizationByShortNameResult,
} from '@shared/models/organization';
import { ORGANIZATION_FRAGMENT } from './auth.queries';

export const GET_ORGANIZATION_BY_SHORT_NAME: TypedDocumentNode<
  IGetOrganizationByShortNameResult,
  IGetOrganizationByShortNameInput
> = gql`
  ${ORGANIZATION_FRAGMENT}
  query getOrganizationByShortName($shortName: String!) {
    getOrganizationByShortName(shortName: $shortName) {
      ...OrganizationFragment
    }
  }
`;
